import React, { useEffect, useRef, useState } from "react";

// component
import NotificationsPanel from "./NotificationPanel";
import Badge from "../../bradge/Badge";

// store
import { fetchUnreadCount } from "../../../../reducer/slices/notifications/unread-count";
import { useDispatch, useSelector } from "react-redux";

// api
import axios from "axios";
import { ENDPOINTS } from "../../../../js/api/_config";
import { useSignalR } from "../../../../context/Signalr-context";


const Notification = () => {
  const [isHover, setIsHover] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("All");

  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingNotifications, setLoadingNotifications] = useState(false);

  const dispatch = useDispatch();
  const notify_unread_count = useSelector((state) => state.notify_unread_count);
  const { counts } = notify_unread_count || {};
  const [currentCount, setCurrentCount] = useState(0)
  const { hubConnection } = useSignalR();
  const pageRef = useRef(page);

  const wrapperRef = useRef(null);
  const listRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);

    if (!isOpen) {
      setNotifications([]);
      setPage(1);
      setHasMore(true);
      fetchNotifications(1, activeTab);
    }
  };

  useEffect(() => {
    fetchNotifications(1, activeTab, true);
  }, [activeTab]);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);


  useEffect(() => {
    if (!hubConnection) return;
    
    const handleNotification = (message) => {
      
      const { event_type } = message;
      if (event_type === "Patient-Conversation-Incoming") {
        fetchNotifications(1, activeTab, false, true);
      }
  };

  // ✅ register listener
  hubConnection.on("notification", handleNotification);

  // ✅ cleanup
  return () => {
    hubConnection.off("notification", handleNotification);
  };

}, [hubConnection, activeTab]);

  const fetchNotifications = async (
    pageNum = page,
    tab = activeTab,
    tab_changed = false,
    isFromHub = false
  ) => {
    if (!tab_changed && !isFromHub) {
      if (loadingNotifications || !hasMore) return;
    }
    if (tab_changed) {
      setNotifications([]);      // clear UI
      setHasMore(true);
      setPage(1);
      setLoadingNotifications(true); // 🔥 SHOW LOADER IMMEDIATELY
      pageNum = 1; 
    } 
    if (!isFromHub) {
      setLoadingNotifications(true);
    }

    try {
      const res = await axios.get(
        `${ENDPOINTS.NOTIFICATION.GET_ALL_NOTIFICATIONS}`,
        {
          params: {
            Page: pageNum,
            PageSize: 10,
            IsRead: tab === "Unread" ? false : "",
          },
        }
      );

      const items = res?.data?.data?.items || [];

     // ✅ 🔥 HANDLE HUB UPDATE (SCROLL SAFE)
    if (isFromHub) {
      const container = listRef.current;

      if (!container) {
        setNotifications((prev) => {
          const remaining = prev.slice(items.length);
          return [...items, ...remaining];
        });
        return;
      }

      const prevScrollHeight = container.scrollHeight;
      const prevScrollTop = container.scrollTop;

      // ✅ Detect if user is near top
      const isNearTop = prevScrollTop <= 10;

      setNotifications((prev) => {
        const remaining = prev.slice(items.length);
        return [...items, ...remaining];
      });

      requestAnimationFrame(() => {
        const newScrollHeight = container.scrollHeight;

        // ✅ Only adjust scroll if user is NOT at top
        if (!isNearTop) {
          container.scrollTop =
            prevScrollTop + (newScrollHeight - prevScrollHeight);
        }
      });
    }
    // ✅ NORMAL FLOW
    else if (pageNum === 1) {
      setNotifications(items);
    } else {
      setNotifications((prev) => [...prev, ...items]);
    }

      if (items.length < 10) setHasMore(false);
      else {if (!isFromHub) {
        setPage(pageNum + 1);
      }}
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    } finally {
      setLoadingNotifications(false);
    }
  };

  useEffect(() => {
    //setNotifications([]);
    setPage(1);
    setHasMore(true);
    
    if (isOpen) {
      if (currentCount == counts.allCount) return
      fetchNotifications(1, activeTab, true);
      
      setCurrentCount(counts.allCount)
    }
  }, [activeTab, isOpen,counts]);

  useEffect(() => {
    dispatch(fetchUnreadCount());
  }, []);

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current?.contains(event.target)) return;

      if (event.target.closest(".notifications-panel-popup")) return;

      setIsOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={wrapperRef}>
      <Badge
        count={counts?.allCount}
        classes={`absolute z-10 -right-[0px] -top-[7px] ${
          counts?.allCount > 99 ? "w-[24px] -right-[5px]" : ""
        }`}
        innerClasses={`text-[10px] font-bold ${counts?.allCount > 99 ? "w-[24px] rounded-xl" : ""}`}
      />

      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className="w-9 h-9 blue_bg rounded-[50%] flex items-center cursor-pointer justify-center relative"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="23"
          fill="none"
          onClick={toggleDropdown}
        >
          <path
            d="M7.84998 0C4.45442 0 1.82724 2.97603 2.24841 6.34536L2.32776 6.98021C2.44388 7.90916 2.10455 8.83706 1.41654 9.47195C-0.00913656 10.7875 -0.405232 12.8815 0.441418 14.6269L0.544769 14.84C1.33394 16.4669 2.98324 17.5 4.79147 17.5H13.0123C14.572 17.5 16.0236 16.7032 16.8611 15.3873C18.0432 13.5299 17.7301 11.0932 16.1168 9.59496L16.0729 9.5542C15.3344 8.86833 14.9708 7.86912 15.0958 6.86901L15.1604 6.35208C15.582 2.97918 12.952 0 9.55289 0H7.84998Z"
            fill="white"
          />
          <path
            d="M6.53339 19.3C6.28486 18.9686 5.81476 18.9015 5.48339 19.15C5.15202 19.3985 5.08487 19.8686 5.33339 20.2L5.63339 20.6C7.28339 22.8 10.5834 22.8 12.2334 20.6L12.5334 20.2C12.7819 19.8686 12.7148 19.3985 12.3834 19.15C12.052 18.9015 11.5819 18.9686 11.3334 19.3L11.0334 19.7C9.98339 21.1 7.88339 21.1 6.83339 19.7L6.53339 19.3Z"
            fill="white"
          />
        </svg>

        {isOpen && (
          <div className="absolute z-20 top-12 right-0 shadow-lg rounded-lg w-[600]">
            <NotificationsPanel
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              notifications={notifications}
              loadingNotifications={loadingNotifications}
              fetchMore={() => fetchNotifications(page, activeTab)}
              hasMore={hasMore}
              toggleDropdown={toggleDropdown}
              listRef={listRef}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Notification;
